﻿import { PlanType } from "../../auth/planProvider/PlanProvider.types";
import { LoginProvider } from "../../user/User.types";
import { PlanStatus } from "../customers/Customers.types";

export interface CustomerSaveModel {
    id: string;
    name: string;
    language: string;
    active: boolean;
    loginProvider: LoginProvider;
    reportTypes: Array<number>;
    helpLink: string;
    planType: PlanType;
    germanEnabled: boolean;
}

export enum CustomerReportType {
    RegistrationOfResearchProject = 1,
    InternalAcquisitionOfSignature = 2,
    ResearchEthicsApproval = 3,
    ApprovalOfQualityProject = 4,
}
